<template>
  <div v-if="isNotCustomAdmin || isSuperAdmin">
    <div class="left_nav">

    	<div class="left_nav_items">
  	    <b-nav>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToSummaryView" :active="active === 'summary'" :aria-label="$tf('summaryNavAria', 'Summary')">
            {{ $tf('summary', 'Summary') }}
          </b-nav-item>
          <b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToChildView" :active="active === 'child'" v-if="institutionCount > 1" :aria-label="$tf('myInstitutionsNavAria', 'My Institutions')">
            {{ $tf('myInstitutions', 'My Institutions') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToDetailsView" :active="active === 'details'" :aria-label="$tf('detailsNavAria', 'Details')">
            {{ $tf('details', 'Details') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToUsersView" :active="active === 'users'" :aria-label="$tf('usersNavAria', 'Users')">
            {{ $tf('users', 'Users') }}
          </b-nav-item>
        	<b-nav-item :disabled="isSuperAdmin || !menuOptionsEnabled" @click="navigateToFoldersView" :active="active === 'folders'" :aria-label="$tf('foldersNavAria', 'Folders')">
            {{ $tf('folders', 'Folders') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToReportsView" :active="active === 'reports'" :aria-label="$tf('reportsAria', 'Reports')">
            {{ $tf('reports', 'Reports') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToPackagesView" :active="active === 'packages'" :aria-label="$tf('packagesNavAria', 'Packages')">
            {{ $tf('packages', 'Packages') }}
          </b-nav-item>
          <b-nav-item v-if="isSuperAdmin" :disabled="!menuOptionsEnabled" @click="navigateToEmployerMappingView" :active="active === 'institutionEmployerMapping'" :aria-label="$tf('employerMapping', 'Employers')">
            {{ $tf('employerMapping', 'Employers') }}
          </b-nav-item>          
          <b-nav-item :disabled="isSuperAdmin || !menuOptionsEnabled" @click="navigateToOtherEntitiesView" :active="active === 'otherEntities'" :aria-label="$tf('otherEntitiesNavAria', 'Other Entities')">
            {{ $tf('otherEntities', 'Other Entities') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToConfigurationView" :active="active === 'configuration'" :aria-label="$tf('configurationNavAria', 'Configuration')">
            {{ $tf('configuration', 'Configuration') }}
          </b-nav-item>
          <b-nav-item :disabled="isSuperAdmin || !menuOptionsEnabled" @click="navigateToEmailCampaigns" :active="active === 'email'" :aria-label="$tf('emailCampaignsNavAria', 'Email Campaigns')">
            {{ $tf('emailCampaigns', 'Email Campaigns') }}
          </b-nav-item>
          <b-nav-item :disabled="isSuperAdmin || !menuOptionsEnabled" @click="navigateToLandingPages" :active="active === 'email'" :aria-label="$tf('landingPagesNavAria', 'Landing Pages')">
            {{ $tf('landingPages', 'Landing Pages') }}
          </b-nav-item>
          <b-nav-item :disabled="isSuperAdmin || !menuOptionsEnabled" @click="navigateToPaymentGateway" :active="active === 'paymentgateway'" :aria-label="$tf('eCommerceNavAria', 'E-Commerce')">
            {{ $tf('eCommerce', 'E-commerce') }}
          </b-nav-item>
          <b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToApiConfigView" :active="active === 'apiConfig'" :aria-label="$tf('apiConfigNavAria', 'API Configuration')">
            {{ $tf('apiConfig', 'API Configuration') }}
          </b-nav-item>
          <b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToSelfRegistrationConfig" :active="active === 'selfRegistration'" v-if="showSelfRegistrationLinkConfig" :aria-label="$tf('selfRegistrationLinkNavAria', 'Self Registration Link')">
            {{ $tf('selfRegistrationLink', 'Self Registration Link') }}
          </b-nav-item>
        	<b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToWidgetView" :active="active === 'exploreWidget'" :aria-label="$tf('exploreWidgetConfigNavAria', 'Explore Widget Configuration')">
            {{ $tf('exploreWidgetConfig', 'Explore Widget Configuration') }}
          </b-nav-item>
          <b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToCourseWidgetView" :active="active === 'courseWidget'" :aria-label="$tf('courseWidgetConfigNavAria', 'Course Widget Configuration')">
            {{ $tf('courseWidgetConfig', 'Course Reporting Widget Configuration') }}
          </b-nav-item>
          <b-nav-item :disabled="!menuOptionsEnabled" @click="navigateToConfigureKCDescription" :active="active === 'kcDescription'"  :aria-label="$tf('kcDescriptionNavAria', 'Configure Knowledge Check Description')">
            {{ $tf('kcDescription', 'Configure Knowledge Check Description') }}
          </b-nav-item>
  	    </b-nav>
    	</div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'institutionMenu',
  props: ['uuid', 'active'],
  components: {
  },
  data: () => {
    return {
      summary: 'summary',
      details: 'details',
      users: 'users',
      folders: 'folders',
      reports: 'reports',
      otherEntities: 'otherEntities',
      packages: 'packages',
      configuration: 'configuration',
      create: 'create',
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION',
      superAdminLearningSpaceName: 'Pragya Root Learning Space',
      institutionCount:1
    }
  },
  async created () {
    this.institutionCount = await this.getAllUserAccountCount()
  },
  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'getAllUserAccountCount'
    ]),
    navigateToSummaryView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionSummary', params: { uuid: this.uuid } })
    },
    navigateToChildView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'ChildInstitutionSwitch', params: { uuid: this.uuid } })
    },
    navigateToDetailsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionDetails', params: { uuid: this.uuid } })
    },
    navigateToUsersView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'listUsers', params: { parentSpaceId: this.uuid } })
    },
    navigateToFoldersView () {
      if (this.isSuperAdmin || !this.menuOptionsEnabled) return
      return this.$router.push({ name: 'folderList' })
    },
    navigateToReportsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionReports', params: { uuid: this.uuid } })
    },
    navigateToOtherEntitiesView () {
      if (this.isSuperAdmin || !this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionEntities', params: { uuid: this.uuid } })
    },
    navigateToPackagesView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionPackages', params: { uuid: this.uuid } })
    },
    navigateToConfigurationView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionConfiguration', params: { uuid: this.uuid } })
    },
    navigateToSelfRegistrationConfig () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'selfRegistrationLinkConfig', params: { uuid: this.uuid } })
    },
    navigateToWidgetView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionWidgetDetail', params: { uuid: this.uuid } })
    },
    navigateToApiConfigView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionApiConfiguration', params: { uuid: this.uuid } })
    },
    navigateToEmployerMappingView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionEmployerMapping', params: { uuid: this.uuid } })
    },
    navigateToEmailCampaigns () {
      return this.$router.push({ name: 'emailCampaignList', params: { uuid: this.uuid } })
    },
    navigateToLandingPages () {
      return this.$router.push({ name: 'selfRegistrationConfiguration', params: { uuid: this.uuid } })
    },
    navigateToPaymentGateway () {
      return this.$router.push({ name: 'institutionPaymentGateway', params: { uuid: this.uuid } })
    },
    navigateToCourseWidgetView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionCourseWidgetDetail', params: { uuid: this.uuid } })
    },
    navigateToConfigureKCDescription () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'institutionKnowledgeCheckDescription', params: { uuid: this.uuid } })
    }
  },

  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'permission': state => state.user.permission
    }),
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    },
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    },
    menuOptionsEnabled () {
      let currentPage = this.active
      let createPage = this.create
      return currentPage !== createPage
    },
    showSelfRegistrationLinkConfig () {
      let showSelfRegLinkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_SELF_REGISTRATION_LINK_FEATURE_ID]
      return showSelfRegLinkFeature && showSelfRegLinkFeature.enabled
    }
  },

  watch: {
    institution (newInstitution) {
      let institutionTitle = newInstitution ? newInstitution.title : ''
      if (institutionTitle === this.superAdminLearningSpaceName) {
        return this.$router.push({ name: 'institutionList' })
      }
    }
  }
}
</script>
<style>
.institution-left-panel {
	.institution-left-panel {
		max-width:164px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionMenu.vue